import { Component, h, Prop, State, Element } from '@stencil/core';
import gearbox from 'qumra-gearbox';

@Component({
  tag: 'qumra-cart-button',
  styleUrl: 'qumra-cart-button.css',
  shadow: true,
})
export class QumraCartButton {
  @Element() el: HTMLElement;

  @State() itemsCount: number = 0;
  @State() hasSlotContent: boolean = false; // حالة جديدة للتحقق من وجود محتوى في الـ slot

  @Prop() href: string = '/cart';

  @Prop() text: string = 'السلة';
  @Prop() showtext: string = "false";
  @Prop() textsize: string = '24px';
  @Prop() textcolor: string = '#000';

  @Prop() iconsize: string = '20px';
  @Prop() iconcolor: string = '#000';

  @Prop() badgesize: string = '14px';


  // disconnectedCallback() {
  //   window.Qumra.events.off("cart::updated");
  // }

  handleStorageEvent(event: StorageEvent) {
    if (event.storageArea === localStorage) {
      this.updateItemCount();
    }
  }

  updateItemCount() {
    const cart = JSON.parse(localStorage.getItem('cart') || '{}');
    const itemsCount = cart.itemsCount || 0;
    this.itemsCount = itemsCount;
  }

  componentDidLoad() {
    // تنفيذ الكود بعد تحميل الصفحة بالكامل
    window.onload = () => {
      this.updateComponentState();
    };
  }
  
  updateComponentState() {
    this.updateItemCount();
  
    window.Qumra.events.on("cart::updated", (data) => {
      this.itemsCount = data.itemsCount;
    });
  
    const slot = this.el.shadowRoot.querySelector('slot');
    if (slot) {
      const assignedNodes = slot.assignedNodes();
      this.hasSlotContent = assignedNodes.length > 0;
    }
  }

  test() {
    gearbox.notify.success('test');
  }
  hexToRgb(hex: string) {
    hex = hex.replace('#', '');
    if (hex.length === 3) {
      hex = hex.split('').map(x => x + x).join(''); 
    }
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return {
      r: isNaN(r) ? 0 : r,
      g: isNaN(g) ? 0 : g,
      b: isNaN(b) ? 0 : b
    };
  }
    lightenColor(rgb: { r: number; g: number; b: number }, percentage: number) {
    return {
      r: Math.round(rgb.r + (255 - rgb.r) * percentage),
      g: Math.round(rgb.g + (255 - rgb.g) * percentage),
      b: Math.round(rgb.b + (255 - rgb.b) * percentage),
    };
  }


  render() {
    const rgbColor = this.hexToRgb(this.iconcolor);
    const lightenedColor = this.lightenColor(rgbColor, 0.9);
    const lightenedBadgeColor = `rgb(${lightenedColor.r}, ${lightenedColor.g}, ${lightenedColor.b})`;
    
    return (
      <a class="qumra-cart-button transtion hover:scale-110" href="/cart" style={{background:lightenedBadgeColor}}>
        <span class="qumra-cart-badge" style={{ background: this.iconcolor, height: this.badgesize, width: this.badgesize }}>
          {this.itemsCount}
        </span>
        {!this.hasSlotContent && (
          <div class="qumra-cart-content">
              <svg fill={this.iconcolor} width={this.iconsize} height={this.iconsize} viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.5 2.25C1.5 1.83579 1.83579 1.5 2.25 1.5H3.87846C4.75256 1.5 5.49261 2.14498 5.61205 3.01088L5.67955 3.50024C10.2591 3.51263 14.7281 3.99872 19.0398 4.91236C19.4395 4.99706 19.6979 5.38613 19.6209 5.7874C19.2145 7.90548 18.6717 9.97515 18.002 11.9869C17.9 12.2933 17.6134 12.5 17.2904 12.5H6.5C6.38567 12.5 6.27351 12.5076 6.16393 12.5223C5.28545 12.64 4.55092 13.2153 4.20796 14H17.75C18.1642 14 18.5 14.3358 18.5 14.75C18.5 15.1642 18.1642 15.5 17.75 15.5H3.25948C3.05068 15.5 2.85133 15.413 2.7094 15.2598C2.56747 15.1067 2.4958 14.9013 2.51164 14.6931C2.63566 13.0628 3.73526 11.7069 5.22829 11.2066L4.12612 3.21584C4.10906 3.09214 4.00333 3 3.87846 3H2.25C1.83579 3 1.5 2.66421 1.5 2.25Z"
                  fill={this.iconcolor} />
                <path d="M6.5 18C6.5 18.8284 5.82843 19.5 5 19.5C4.17157 19.5 3.5 18.8284 3.5 18C3.5 17.1716 4.17157 16.5 5 16.5C5.82843 16.5 6.5 17.1716 6.5 18Z" fill={this.iconcolor} />
                <path d="M16 19.5C16.8284 19.5 17.5 18.8284 17.5 18C17.5 17.1716 16.8284 16.5 16 16.5C15.1716 16.5 14.5 17.1716 14.5 18C14.5 18.8284 15.1716 19.5 16 19.5Z" fill={this.iconcolor} />
              </svg>
            {this.showtext === "true" ? (
              <div>
                <p style={{ color: this.textcolor, fontSize: this.textsize }}>{this.text}</p>
              </div>
            ) : null}
          </div>
        )}
        <slot></slot>
      </a>
    );
  }
}
